import ClientBase from "Services/API/ClientBase";
import { useContext, useMemo } from "react";
import { LayoutContext } from "Components/LayoutContext";

export function useApiClient<T extends ClientBase>(clientType: new (baseUrl?: string) => T): T {
   const layoutContext = useContext(LayoutContext);

   const client = useMemo(() => {
      const client = new clientType();
      client.onError = (message, httpStatus) => {
         console.log("API client error", message, httpStatus);
         layoutContext.showError(message);
      };
      return client;
   }, [clientType]);

   return client;
}